


import React, { useEffect, useState, useCallback, useRef } from 'react';
import './CateringMenu.css';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';
import { BsInfoCircleFill } from "react-icons/bs";
import Vendorbanner from '../Catering/Vendorbanner.jsx';

const ShoppingCartIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="9" cy="21" r="1" /><circle cx="20" cy="21" r="1" />
        <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
    </svg>
);

const CloseIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
    </svg>
);

const LocationIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="12" cy="12" r="3" />
        <path d="M12 2a10 10 0 0 0-10 10c0 5.5 10 18 10 18s10-12.5 10-18a10 10 0 0 0-10-10z" />
    </svg>
);

const CateringMenu = () => {
    const navigate = useNavigate();

    // Catering Packages State
    const [packages, setPackages] = useState([]);
    const [filteredPackages, setFilteredPackages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Filter States
    const [isVegSelected, setIsVegSelected] = useState(false);
    const [isNonVegSelected, setIsNonVegSelected] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    // Cart States
    const [cartItems, setCartItems] = useState([]);
    const [subTotal, setSubTotal] = useState(0);
    const [gstTotal, setGstTotal] = useState(0);
    const [serviceCharges, setServiceCharges] = useState(0);
    const [grandTotal, setGrandTotal] = useState(0);
    const [cartId, setCartId] = useState(null);
    const [quantities, setQuantities] = useState({});

    // Delivery & DateTime States
    const [deliveryAddress, setDeliveryAddress] = useState(null);
    const [showAddressModal, setShowAddressModal] = useState(false);
    const [cateringDate, setCateringDate] = useState("");
    const [cateringTime, setCateringTime] = useState("");
    const [showDateTimeModal, setShowDateTimeModal] = useState(false);

    // Payment States
    const [showPaymentOptions, setShowPaymentOptions] = useState(false);
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
    const [selectedWalletType, setSelectedWalletType] = useState("");
    const [orderId, setOrderId] = useState(null);
    const [availableBalance, setAvailableBalance] = useState(0);
    const [availableCompany, setAvailableCompany] = useState(0);
    const [availableSelf, setAvailableSelf] = useState(0);
    const [availableCashback, setAvailableCashback] = useState(0);
    const [orderPlacing, setOrderPlacing] = useState(false);
    const [showPaymentData, setShowPaymentData] = useState(false);

    // UI States
    const [isCartPanelOpen, setIsCartPanelOpen] = useState(false);
    const [serviceApplied, setServiceApplied] = useState(true);
    const [showGstPopup, setShowGstPopup] = useState(false);
    const [gstBreakdownData, setGstBreakdownData] = useState(null);

    // Checkbox states for payment
    const [isWalletChecked, setIsWalletChecked] = useState(false);
    const [isOnlineChecked, setIsOnlineChecked] = useState(false);
    const [showWalletOptions, setShowWalletOptions] = useState(false);
    const [paymentBreakdown, setPaymentBreakdown] = useState(null);

    // Google Maps References
    const [mapLoaded, setMapLoaded] = useState(false);
    const [searchInput, setSearchInput] = useState("");
    const [selectedPlace, setSelectedPlace] = useState(null);
    const [loadingLocation, setLoadingLocation] = useState(false);
    const autocompleteRef = useRef(null);
    const searchInputRef = useRef(null);

const GOOGLE_MAPS_API_KEY = "AIzaSyDRcDLmtI8sk6pFB3w1o1N0RyPnRYO2HXQ";
const mapRef = useRef(null);
const markerRef = useRef(null);


const [latitude, setLatitude] = useState(null);
const [longitude, setLongitude] = useState(null);


    const getAuthVars = () => {
        const userId = localStorage.getItem("userId");
        const token = localStorage.getItem("authToken");
        return { userId, token };
    };

    const getVendorId = () => {
        return localStorage.getItem("vendorId") || "98";
    };


    const initMap = () => {
  if (!window.google) return;

  const defaultLocation = { lat: 20.5937, lng: 78.9629 };

  mapRef.current = new window.google.maps.Map(
    document.getElementById("address-map"),
    {
      center: defaultLocation,
      zoom: 5,
      mapTypeControl: false,
      streetViewControl: false
    }
  );

  markerRef.current = new window.google.maps.Marker({
    map: mapRef.current,
    draggable: true
  });

  // 👉 Marker drag
  markerRef.current.addListener("dragend", (e) => {
    const lat = e.latLng.lat();
    const lng = e.latLng.lng();

    setLatitude(lat);
    setLongitude(lng);

    reverseGeocode(lat, lng);
  });
};

const reverseGeocode = (lat, lng) => {
  const geocoder = new window.google.maps.Geocoder();

  geocoder.geocode({ location: { lat, lng } }, (results, status) => {
    if (status === "OK" && results[0]) {
      const address = results[0].formatted_address;

      setSearchInput(address);
      setDeliveryAddress({ address });
      setSelectedPlace(results[0]);
    }
  });
};


    // Calculate Totals
    const calculateTotals = useCallback((items) => {
    let sub = 0;

    items.forEach(item => {
        const price = parseFloat(item.packagePrice || item.price || 0);
        const qty = item.quantity || 1;

        sub += price * qty;
    });

    const gst = sub * 0.05;
    const service = sub * 0.1;

    const total = sub + gst + (serviceApplied ? service : 0);

    console.log("✅ FINAL TOTAL:", total);

    setSubTotal(sub);
    setGstTotal(gst);
    setServiceCharges(service);
    setGrandTotal(total);

    return { subTotal: sub, gstTotal: gst, serviceCharges: service, grandTotal: total };
}, [serviceApplied]);

    // Fetch Cart Details
    const fetchCartDetails = useCallback(async () => {
        const { userId, token } = getAuthVars();
        if (!userId) return;

        try {
            const response = await axios.get(
                `https://backend.maamaas.com/catering/api/user/get/cart?userId=${userId}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            const cartData = response.data;
            let items = [];
            let cartIdFromResponse = null;

            if (cartData && cartData.items && Array.isArray(cartData.items)) {
                items = cartData.items;
                cartIdFromResponse = cartData.id || cartData.cartId;

                if (cartData.deliveryAddress) setDeliveryAddress({ address: cartData.deliveryAddress });
                if (cartData.cateringDate) setCateringDate(cartData.cateringDate);
                if (cartData.cateringTime) {
                    let timeValue = cartData.cateringTime;
                    if (timeValue && timeValue.includes(':')) {
                        timeValue = timeValue.substring(0, 5);
                    }
                    setCateringTime(timeValue);
                }
            } else if (cartData && cartData.cartItems && Array.isArray(cartData.cartItems)) {
                items = cartData.cartItems;
                cartIdFromResponse = cartData.cartId;
                if (cartData.deliveryAddress) setDeliveryAddress({ address: cartData.deliveryAddress });
                if (cartData.cateringDate) setCateringDate(cartData.cateringDate);
                if (cartData.cateringTime) setCateringTime(cartData.cateringTime);
            }

            if (cartIdFromResponse) {
                setCartId(cartIdFromResponse);
                localStorage.setItem("cateringCartId", cartIdFromResponse);
            }

            const normalizedItems = items.map(item => ({
                ...item,
                packageId: item.packageId || item.package?.id || item.id,
                packageName: item.packageName || item.package?.packageName,
                packageType: item.packageType || item.package?.packageType,
                price: item.price || item.package?.price || item.totalPrice || item.packagePrice || 0
            }));

            setCartItems(normalizedItems);
            const initialQuantities = {};
            normalizedItems.forEach(item => {
                initialQuantities[item.packageId] = item.quantity || 1;
            });
            setQuantities(initialQuantities);
            calculateTotals(normalizedItems);
        } catch (error) {
            console.error("Error fetching cart:", error);
            setCartItems([]);
        }
    }, [calculateTotals]);

    // Initialize Google Maps Autocomplete
   const initAutocomplete = useCallback(() => {
  if (!window.google || !window.google.maps.places) return;

  if (searchInputRef.current && !autocompleteRef.current) {
    autocompleteRef.current = new window.google.maps.places.Autocomplete(
      searchInputRef.current,
      {
        types: ["geocode"],
        componentRestrictions: { country: "IN" }
      }
    );

    autocompleteRef.current.addListener("place_changed", () => {
      const place = autocompleteRef.current.getPlace();

      if (!place.geometry) return;

      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();

      setSelectedPlace(place);
      setSearchInput(place.formatted_address);
      setDeliveryAddress({ address: place.formatted_address });

      moveMap(lat, lng); // 🔥 ADD THIS

      toast.success("Address selected!");
    });
  }
}, []);

const moveMap = (lat, lng) => {
  setLatitude(lat);
  setLongitude(lng);

  if (mapRef.current) {
    mapRef.current.setCenter({ lat, lng });
    mapRef.current.setZoom(16);
  }

  if (markerRef.current) {
    markerRef.current.setPosition({ lat, lng });
    markerRef.current.setVisible(true);
  }
};


    // Load Google Maps Script
    useEffect(() => {
        if (document.querySelector('script[src*="maps.googleapis.com/maps/api/js"]')) {
            setMapLoaded(true);
            return;
        }

        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyDRcDLmtI8sk6pFB3w1o1N0RyPnRYO2HXQ&libraries=places`;
        script.async = true;
        script.defer = true;
        script.onload = () => setMapLoaded(true);
        script.onerror = () => toast.error("Failed to load Google Maps");
        document.head.appendChild(script);
    }, []);

    useEffect(() => {
        if (mapLoaded && showAddressModal) {
            setTimeout(() => initAutocomplete(), 100);
        }
    }, [mapLoaded, showAddressModal, initAutocomplete]);


useEffect(() => {
  if (mapLoaded && showAddressModal) {
    setTimeout(() => {
      initMap();           // 🔥 ADD THIS
      initAutocomplete();
    }, 300);
  }
}, [mapLoaded, showAddressModal]);
    // Get Current Location
    const getCurrentLocation = () => {
  setLoadingLocation(true);

  

  navigator.geolocation.getCurrentPosition(
    async (position) => {
      const { latitude, longitude } = position.coords;

      moveMap(latitude, longitude); // 🔥 ADD THIS

      try {
        const res = await axios.get(
          `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=AIzaSyDRcDLmtI8sk6pFB3w1o1N0RyPnRYO2HXQ`
        );

        if (res.data.results?.[0]) {
          const address = res.data.results[0].formatted_address;

          setSearchInput(address);
          setDeliveryAddress({ address });
          setSelectedPlace(res.data.results[0]);
        }
      } catch {
        toast.error("Failed to get address");
      }

      setLoadingLocation(false);
    },
    () => {
      toast.error("Location error");
      setLoadingLocation(false);
    }
  );
};

    // Fetch Catering Packages
    const fetchCateringPackages = useCallback(async () => {
        const vendorId = getVendorId();
        const { token } = getAuthVars();

        setLoading(true);
        try {
            const response = await axios.get(
                `https://backend.maamaas.com/catering/api/package/${vendorId}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            const packagesData = Array.isArray(response.data) ? response.data : [];

            const packagesWithTotals = packagesData.map(pkg => ({
                ...pkg,
                calculatedTotal: pkg.items?.reduce((sum, item) => sum + (parseFloat(item.price) || 0), 0) || parseFloat(pkg.totalPrice) || 0
            }));

            setPackages(packagesWithTotals);
            setFilteredPackages(packagesWithTotals);
        } catch (error) {
            setError(error);
            toast.error("Failed to load packages");
        } finally {
            setLoading(false);
        }
    }, []);

    // Save Delivery Address
    const saveDeliveryAddress = async (address) => {
        if (!address?.trim()) {
            toast.error("Please enter a valid address");
            return false;
        }
        localStorage.setItem("cateringDeliveryAddress", address);
        setDeliveryAddress({ address });
        toast.success("Address saved!");
        return true;
    };

    // Load saved address
    useEffect(() => {
        const savedAddress = localStorage.getItem("cateringDeliveryAddress");
        if (savedAddress) setDeliveryAddress({ address: savedAddress });
    }, []);

    // Fetch Wallet Data
    const fetchWalletData = useCallback(async () => {
        const { userId, token } = getAuthVars();
        if (!userId || !token) return;
        try {
            const response = await axios.get(
                `https://backend.maamaas.com/subscription/api/user/wallet/${userId}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            const data = response.data || {};
            setAvailableBalance(data.totalBalance || 0);
            setAvailableCompany(data.companyLoadedAmount || 0);
            setAvailableSelf(data.selfLoadedAmount || 0);
            setAvailableCashback(data.cashbackAmount || 0);
        } catch (error) {
            console.error("Wallet fetch error:", error);
        }
    }, []);

    // Filter Packages
    useEffect(() => {
        let filtered = [...packages];
        if (searchTerm) {
            filtered = filtered.filter(pkg =>
                pkg.packageName?.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }
        if (isVegSelected) {
            filtered = filtered.filter(pkg => pkg.packageType === "Veg");
        } else if (isNonVegSelected) {
            filtered = filtered.filter(pkg => pkg.packageType === "Non_veg");
        }
        setFilteredPackages(filtered);
    }, [packages, searchTerm, isVegSelected, isNonVegSelected]);

    // Initial Data Fetch
    useEffect(() => {
        fetchCateringPackages();
        fetchCartDetails();
        fetchWalletData();
    }, [fetchCateringPackages, fetchCartDetails, fetchWalletData]);

    // Recalculate totals
    useEffect(() => {
        calculateTotals(cartItems);
    }, [cartItems, serviceApplied, calculateTotals]);

    // Handle window resize
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
            if (window.innerWidth > 768) setIsCartPanelOpen(false);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Add to Cart
    const addToCart = async (pkg, quantity = 1) => {
        const { userId, token } = getAuthVars();
        if (!userId || !token) {
            toast.error("Please login first");
            return;
        }

        const packageTotal = pkg.calculatedTotal || getPackageTotal(pkg);

        try {
            await axios.post(
                "https://backend.maamaas.com/catering/api/user/cart/add",
                {
                    userId: Number(userId),
                    packageId: pkg.id,
                    quantity,
                    customerId: "default",
                    price: packageTotal
                },
                { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
            );

            toast.success(`${pkg.packageName} added to cart!`);
            await fetchCartDetails();
        } catch (error) {
            toast.error(error.response?.data?.message || "Failed to add to cart");
        }
    };

    // Update Cart Item
    const updateCartItem = async (item, newQuantity) => {
        if (!cartId) {
            toast.error("Cart not loaded");
            return false;
        }

        const { userId, token } = getAuthVars();
        try {
            await axios.put(
                `https://backend.maamaas.com/catering/api/user/updatequantity/${cartId}`,
                {
                    userId: Number(userId),
                    packageId: item.packageId,
                    quantity: newQuantity,
                    cartItemId: item.id
                },
                { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
            );
            return true;
        } catch (error) {
            toast.error("Update failed");
            return false;
        }
    };

    // Increment Quantity
    const incrementQuantity = async (item) => {
        const currentQty = quantities[item.id] || item.quantity;
        const newQty = currentQty + 1;

        setQuantities(prev => ({ ...prev, [item.id]: newQty }));
        setCartItems(prev => prev.map(it => it.id === item.id ? { ...it, quantity: newQty } : it));

        const success = await updateCartItem(item, newQty);
        if (!success) {
            setQuantities(prev => ({ ...prev, [item.id]: currentQty }));
            setCartItems(prev => prev.map(it => it.id === item.id ? { ...it, quantity: currentQty } : it));
        }
    };

    // Decrement Quantity
    const decrementQuantity = async (item) => {
        const currentQty = quantities[item.id] || item.quantity;
        if (currentQty <= 1) {
            await removeCartItem(item);
            return;
        }

        const newQty = currentQty - 1;
        setQuantities(prev => ({ ...prev, [item.id]: newQty }));
        setCartItems(prev => prev.map(it => it.id === item.id ? { ...it, quantity: newQty } : it));

        const success = await updateCartItem(item, newQty);
        if (!success) {
            setQuantities(prev => ({ ...prev, [item.id]: currentQty }));
            setCartItems(prev => prev.map(it => it.id === item.id ? { ...it, quantity: currentQty } : it));
        }
    };

    // Remove Cart Item
    const removeCartItem = async (item) => {
        const { token } = getAuthVars();
        if (!cartId) {
            toast.error("Cart not loaded");
            return;
        }

        try {
            await axios.delete(
                `https://backend.maamaas.com/catering/api/user/package/${cartId}/${item.packageId}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            await fetchCartDetails();
            toast.success(`${item.packageName} removed`);
        } catch (error) {
            toast.error(error.response?.data?.message || "Failed to remove");
        }
    };

    // Update DateTime
    const updateDateTime = async () => {
        const { token } = getAuthVars();
        if (!token || !cartId) {
            toast.error("Missing required data");
            return false;
        }

        try {
            await axios.put(
                `https://backend.maamaas.com/catering/api/user/${cartId}/datetime`,
                { cateringDate, cateringTime },
                { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
            );
            toast.success("Date & Time updated!");
            return true;
        } catch (error) {
            toast.error(error.response?.data?.message || "Update failed");
            return false;
        }
    };

    // Clear Cart
    const handleClearCart = async () => {
        const { userId, token } = getAuthVars();
        if (!userId) {
            toast.error("User ID not found");
            return;
        }

        try {
            await axios.delete(
                `https://backend.maamaas.com/catering/api/user/clear/cart`,
                { params: { userId }, headers: { Authorization: `Bearer ${token}` } }
            );
            toast.success("Cart cleared!");
            setCartItems([]);
            setQuantities({});
            setGrandTotal(0);
            setSubTotal(0);
            setGstTotal(0);
            setShowPaymentOptions(false);
            setCartId(null);
            localStorage.removeItem("cateringCartId");
            await fetchCartDetails();
        } catch (error) {
            toast.error("Failed to clear cart");
        }
    };

    // Clear cart after order
    const clearCartAfterOrder = async () => {
        const { token, userId } = getAuthVars();

        if (cartId) {
            try {
                await axios.delete(
                    `https://backend.maamaas.com/catering/api/user/clear/cart`,
                    { params: { userId }, headers: { Authorization: `Bearer ${token}` } }
                );
            } catch (err) {
                console.error("Clear cart error:", err);
            }
        }

        localStorage.removeItem("cateringCartId");
        setCartItems([]);
        setCartId(null);
        setQuantities({});
        setShowPaymentOptions(false);
        setShowPaymentData(false);
    };

    // Process Wallet Payment
    const processWalletPayment = async () => {
        const { token, userId } = getAuthVars();
        const cartIdLocal = localStorage.getItem("cateringCartId");

        if (!cartIdLocal || !deliveryAddress?.address || !cateringDate || !cateringTime) {
            toast.error("Missing required information");
            return;
        }

        setOrderPlacing(true);

        try {
            const cartRes = await axios.get(
                `https://backend.maamaas.com/catering/api/user/get/cart?userId=${userId}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            const finalAmount =
                cartRes.data.total ||
                cartRes.data.totalAmount ||
                0;

            if (!finalAmount) {
                toast.error("Cart is empty");
                setOrderPlacing(false);
                return;
            }

            const vendorId = getVendorId();
            const selectedWallet = (selectedWalletType || "SELF_LOADED").toUpperCase();

            const requestBody = {
                userId: Number(userId),
                vendorId: Number(vendorId),

                location: deliveryAddress.address,
                orderDateTime: new Date().toISOString(),

                paymentType: "FULL_PAYMENT",

                // 🔥 FINAL FIX
                paymentMethod: "Maamaas_Wallet",
                paymentMethodSecondary: "WALLET",

                paymentStatus: "SUCCESS",
                orderStatus: "CONFIRMED",

                sgst: Number((finalAmount * 0.006).toFixed(2)),
                cgst: Number((finalAmount * 0.006).toFixed(2)),

                cateringDate: cateringDate,
                cateringTime: getCateringTimeObject(cateringTime),

                fromDate: cateringDate,
                toDate: cateringDate,

                subtotal: Number(subTotal.toFixed(2)),
                platformFeeAmount: Number(serviceCharges.toFixed(2)),
                total: Number(finalAmount.toFixed(2)),

                // ✅ Wallet fields
                walletUsed: Number(finalAmount.toFixed(2)),
                walletTypes: [selectedWallet],

                // ✅ Required IDs
                transactionId: "WALLET_" + Date.now(),
                transactionId2: "WALLET_" + Date.now(),

                amountPaid: Number(finalAmount.toFixed(2)),
                discountAmount: 0,
                amountRemaining: 0,

                orderItems: cartItems.map(item => ({
                    packageId: item.packageId,
                    packageName: item.packageName,
                    packageType: item.packageType,
                    packagePrice: Number(item.price || 0),
                    quantity: item.quantity || 1,
                    itemsName: item.packageName,
                    packageItems: item.items || []
                })),

                mobileNo: localStorage.getItem("userPhone") || "",
                deliveryUserName: localStorage.getItem("userName") || "",
                deliveryFee: 0,

                appType: "CATERINGS",
                deliveryAddress: deliveryAddress.address
            };

            console.log("🟢 WALLET ORDER BODY:", requestBody);

            const response = await axios.post(
                "https://backend.maamaas.com/catering/api/user/orders",
                requestBody,
                {
                    params: {
                        cartId: Number(cartIdLocal),
                        userId: Number(userId),
                        paymentMethod: "Maamaas_Wallet",
                        grandTotal: Number(finalAmount),

                        // 🔥 CRITICAL FIX
                        walletTypes: selectedWallet  // NOT array
                    },
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json"
                    }
                }
            );

            if (response.data) {
                alert("Wallet Payment Successful 🎉");
                showInvoicePopup(response.data);
                await clearCartAfterOrder();
            }

        } catch (error) {
            console.error("❌ Wallet payment error:", error.response?.data || error);
            toast.error(error.response?.data?.message || "Wallet payment failed");
        } finally {
            setOrderPlacing(false);
        }
    };

    // Load Razorpay Script
    const loadRazorpayScript = () => {
        return new Promise((resolve) => {
            if (window.Razorpay) return resolve(true);
            const script = document.createElement("script");
            script.src = "https://checkout.razorpay.com/v1/checkout.js";
            script.onload = () => resolve(true);
            script.onerror = () => resolve(false);
            document.body.appendChild(script);
        });
    };

    const getCateringTimeObject = (timeStr) => {
        if (!timeStr) return { hour: 12, minute: 0, second: 0, nano: 0 };

        const [hour, minute] = timeStr.split(":").map(Number);

        return {
            hour: hour || 0,
            minute: minute || 0,
            second: 0,
            nano: 0
        };
    };

    // Create Order After Payment - MAIN FUNCTION
    const createOrderAfterPayment = async (paymentResponse, finalAmount) => {
        const { token, userId } = getAuthVars();
        const cartIdLocal = localStorage.getItem("cateringCartId");

        const paymentId = paymentResponse?.razorpay_payment_id;
        const orderId = paymentResponse?.razorpay_order_id;
        const signature = paymentResponse?.razorpay_signature;

        if (!paymentId) {
            toast.error("Payment ID missing");
            return;
        }

        try {
            const vendorId = getVendorId();

            const requestBody = {
                userId: Number(userId),
                vendorId: Number(vendorId),
                location: deliveryAddress?.address || "",

                orderDateTime: new Date().toISOString(),

                paymentType: "FULL_PAYMENT",
                paymentMethod: "Online_Payment",
                paymentMethodSecondary: "Online_Payment",

                paymentStatus: "SUCCESS", // ✅ after capture
                orderStatus: "CONFIRMED",

                sgst: Number((finalAmount * 0.006).toFixed(2)),
                cgst: Number((finalAmount * 0.006).toFixed(2)),

                cateringDate: cateringDate,
                cateringTime: getCateringTimeObject(cateringTime),

                fromDate: cateringDate,
                toDate: cateringDate,

                subtotal: Number(subTotal.toFixed(2)),
                platformFeeAmount: Number(serviceCharges.toFixed(2)),
                total: Number(finalAmount.toFixed(2)),

                // ✅ ONLY camelCase
                razorpayPaymentId: paymentId,
                razorpayOrderId: orderId,

                // 🔥 ADD THIS (VERY IMPORTANT)
                paymentId: paymentId,

                // 🔥 ALSO ADD snake_case (backend fallback)
                razorpay_payment_id: paymentId,
                razorpay_order_id: orderId,

                transactionId: paymentId,
                transactionId2: orderId, // ✅ IMPORTANT

                amountPaid: Number(finalAmount.toFixed(2)),
                discountAmount: 0,
                amountRemaining: 0,

                orderItems: cartItems.map(item => ({
                    packageId: item.packageId,
                    packageName: item.packageName,
                    packageType: item.packageType,
                    packagePrice: Number((item.price || 0).toFixed(2)),
                    quantity: item.quantity || 1,
                    itemsName: item.packageName,
                    packageItems: item.items || []
                })),

                mobileNo: localStorage.getItem("userPhone") || "",
                deliveryUserName: localStorage.getItem("userName") || "",
                deliveryFee: 0,

                appType: "CATERINGS",

                deliveryAddress: deliveryAddress?.address || "",

                walletUsed: 0,
                walletTypes: ["SELF_LOADED"]
            };

            console.log("🚀 FINAL ORDER BODY:", requestBody);

            const response = await axios.post(
                "https://backend.maamaas.com/catering/api/user/orders",
                requestBody,
                {
                    params: {
                        cartId: Number(cartIdLocal),
                        userId: Number(userId),
                        paymentMethod: "Online_Payment",
                        grandTotal: Number(finalAmount),

                        // 🔥 THIS IS THE REAL FIX
                        razorpayPaymentId: paymentId,
                        razorpayOrderId: orderId
                    },
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json"
                    }
                }
            );

            if (response.data) {
                alert("Order placed successfully 🎉");
                showInvoicePopup(response.data);
                await clearCartAfterOrder();
            }

        } catch (err) {
            console.error("Order creation error:", err.response?.data || err);
            alert(err.response?.data?.message || "Order creation failed");
        }
    };

    // Handle Payment Success - COMPLETE WORKING FUNCTION
const handlePaymentSuccess = async (response, finalAmount) => {
    const { token } = getAuthVars();

    try {
        const amountInPaise = Math.round(finalAmount * 100);

        const captureRes = await axios.post(
            "https://backend.maamaas.com/subscription/api/user/capture",
            {
                paymentId: response.razorpay_payment_id,
                orderId: response.razorpay_order_id,
                signature: response.razorpay_signature,
                amount: amountInPaise, // 🔥 MUST MATCH
                currency: "INR"
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
        );

        if (!captureRes?.data) {
            alert("Payment capture failed");
            return;
        }

        await createOrderAfterPayment(response, finalAmount);

    } catch (err) {
        console.error("Payment error:", err.response?.data || err);
        alert(err.response?.data?.message || "Payment failed");
    }
};

    // Handle Checkout Click
const handleCheckoutClick = async () => {
    const { token, userId } = getAuthVars();
    const cartIdLocal = localStorage.getItem("cateringCartId");

    if (!cartIdLocal) return alert("Cart not found");
    if (!deliveryAddress?.address) return alert("Please add address");
    if (!cateringDate || !cateringTime) return alert("Select date & time");

    const isLoaded = await loadRazorpayScript();
    if (!isLoaded) return alert("Razorpay SDK failed");

    setOrderPlacing(true);

    try {
        // ✅ STEP 1: Get total (RUPEES)
        const cartRes = await axios.get(
            `https://backend.maamaas.com/catering/api/user/get/cart?userId=${userId}`,
            { headers: { Authorization: `Bearer ${token}` } }
        );

        const finalAmount =
            cartRes.data?.total ||
            cartRes.data?.totalAmount ||
            0;

        if (!finalAmount) {
            toast.error("Cart empty");
            setOrderPlacing(false);
            return;
        }

        // ✅ STEP 2: Convert to paise
        const amountInPaise = Math.round(finalAmount * 100);

        console.log("RUPEES:", finalAmount);
        console.log("PAISE:", amountInPaise);

        // ✅ STEP 3: Create Razorpay order (PAISE ONLY)
        const orderRes = await axios.post(
            "https://backend.maamaas.com/subscription/api/user/create-order",
            {
                amount: amountInPaise, // 🔥 MUST BE PAISE
                currency: "INR",
                userId: Number(userId),
                cartId: Number(cartIdLocal)
            },
            { headers: { Authorization: `Bearer ${token}` } }
        );

        const razorpayOrderId =
            orderRes.data.orderId || orderRes.data.id;

        if (!razorpayOrderId) {
            alert("Order creation failed");
            setOrderPlacing(false);
            return;
        }

        console.log("ORDER ID:", razorpayOrderId);
        console.log("BACKEND AMOUNT:", orderRes.data.amount);

        // ⚠️ IMPORTANT:
        // Razorpay backend amount use karta hai
        // isliye yaha SAME amount use karo
        const razorpayAmount = orderRes.data.amount;

        // ✅ STEP 4: Razorpay options
        const options = {
            key: "rzp_live_RU5whSMu9rPV7s",
            amount: razorpayAmount, // 🔥 backend amount
            currency: "INR",
            name: "Maamaas Foods",
            description: "Catering Payment",
            order_id: razorpayOrderId,

            handler: async function (response) {
                console.log("RAZORPAY RESPONSE:", response);

                if (!response?.razorpay_payment_id) {
                    alert("Payment failed");
                    setOrderPlacing(false);
                    return;
                }

                await handlePaymentSuccess(response, finalAmount);
            },

            modal: {
                ondismiss: () => {
                    alert("Payment cancelled");
                    setOrderPlacing(false);
                }
            },

            prefill: {
                name: localStorage.getItem("userName") || "",
                contact: localStorage.getItem("userPhone") || ""
            },

            theme: { color: "#3399cc" }
        };

        new window.Razorpay(options).open();

    } catch (err) {
        console.error("Checkout error:", err.response?.data || err);
        alert("Checkout failed");
        setOrderPlacing(false);
    }
};
    // Show Invoice Popup
    const showInvoicePopup = (orderData) => {
        setPaymentBreakdown({
            orderId: orderData.orderId || orderData.id,
            totalAmount: orderData.total || grandTotal,
            paidAmount: orderData.amountPaid || grandTotal,
            remainingAmount: orderData.amountRemaining || 0,
            paymentMethod: orderData.paymentMethod || selectedPaymentMethod,
            paymentStatus: orderData.paymentStatus || "COMPLETED",
            subtotal: subTotal,
            gst: gstTotal,
            serviceCharges: serviceApplied ? serviceCharges : 0
        });
        setOrderId(orderData.orderId || orderData.id);
        setShowPaymentData(true);
        setShowPaymentOptions(false);
        setIsWalletChecked(false);
        setIsOnlineChecked(false);
        setSelectedPaymentMethod(null);
        setSelectedWalletType("");
    };

    // Handle Payment Method Selection
    const handleCheckboxChange = (method, isChecked) => {
        if (isChecked) {
            setIsWalletChecked(method === "wallet");
            setIsOnlineChecked(method === "online");
            setSelectedPaymentMethod(method === "wallet" ? "Maamaas_Wallet" : "Online_Payment");
            setShowWalletOptions(method === "wallet");
        } else {
            if (method === "wallet") {
                setIsWalletChecked(false);
                setShowWalletOptions(false);
                if (selectedPaymentMethod === "Maamaas_Wallet") setSelectedPaymentMethod(null);
            }
            if (method === "online") {
                setIsOnlineChecked(false);
                if (selectedPaymentMethod === "Online_Payment") setSelectedPaymentMethod(null);
            }
        }
    };

    // Toggle Service Charges
    const toggleServiceCharges = () => {
        setServiceApplied(!serviceApplied);
        alert(`Service charges ${serviceApplied ? "removed" : "applied"}`);
    };

    // Show GST Breakdown
    const handleShowGST = () => {
        setGstBreakdownData({
            cgst: gstTotal / 2,
            sgst: gstTotal / 2,
            serviceChargeGst: serviceCharges * 0.18
        });
        setShowGstPopup(true);
    };

    const getTotalItems = () => cartItems.reduce((t, i) => t + (i.quantity || 1), 0);
    const cartItemsCount = getTotalItems();

    const getPackageTotal = (pkg) => {
        if (pkg.items?.length) {
            return pkg.items.reduce((sum, item) => sum + (parseFloat(item.price) || 0), 0);
        }
        return parseFloat(pkg.totalPrice) || 0;
    };

    if (loading) return (
        <div className="menu-loading">
            <div className="menu-loading-spinner" />
            <span>Loading Catering Packages...</span>
        </div>
    );

    if (error) return <div className="menu-error">Error: {error.message}</div>;

    // Cart Sidebar Component
    const CartSidebar = ({ isMobileView, onClose }) => (
        <div className={`cart-sidebar ${isMobileView ? 'cart-sidebar--mobile' : 'cart-sidebar--desktop'}`}>
            <div className="cart-header">
                <div className="cart-header-left">
                    <ShoppingCartIcon />
                    <span className="cart-title">Your Cart</span>
                    <span className="cart-badge">{cartItemsCount}</span>
                </div>
                <div className="cart-header-right">
                    {cartItems.length > 0 && !showPaymentData && (
                        <button className="cart-clear-btn" onClick={handleClearCart}>Clear All</button>
                    )}
                    {isMobileView && (
                        <button className="cart-close-btn" onClick={onClose}><CloseIcon /></button>
                    )}
                </div>
            </div>

            {!showPaymentData && (
                <div className="cart-table-banner">
                    <button className="cart-address-btn" onClick={() => setShowAddressModal(true)}>
                        📍 {deliveryAddress?.address ? (deliveryAddress.address.length > 30 ? deliveryAddress.address.substring(0, 30) + "..." : deliveryAddress.address) : "Add Delivery Address"}
                    </button>
                    <button className="cart-datetime-btn" onClick={() => setShowDateTimeModal(true)}>
                        🕐 {cateringDate ? `${cateringDate} ${cateringTime}` : "Set Date & Time"}
                    </button>
                </div>
            )}

            <div className="cart-body">
                {showPaymentData ? (
                    <div className="cart-order-success">
                        <div className="cart-success-icon">✅</div>
                        <h3>Order Placed Successfully!</h3>
                        <p>Order ID: <strong>{orderId}</strong></p>
                        {paymentBreakdown && (
                            <div className="invoice-breakdown">
                                <div className="invoice-header"><h4>📄 Payment Invoice</h4></div>
                                <div className="invoice-row"><span>Subtotal:</span><span>₹{paymentBreakdown.subtotal?.toFixed(2)}</span></div>
                                <div className="invoice-row"><span>GST (5%):</span><span>₹{paymentBreakdown.gst?.toFixed(2)}</span></div>
                                <div className="invoice-row"><span>Service Charges:</span><span>₹{paymentBreakdown.serviceCharges?.toFixed(2)}</span></div>
                                <div className="invoice-row invoice-total"><span>Total Amount:</span><span>₹{paymentBreakdown.totalAmount?.toFixed(2)}</span></div>
                                <div className="invoice-row"><span>Paid Amount:</span><span>₹{paymentBreakdown.paidAmount?.toFixed(2)}</span></div>
                                <div className="invoice-row"><span>Payment Method:</span><span>{paymentBreakdown.paymentMethod}</span></div>
                                <div className="invoice-row"><span>Delivery Address:</span><span>{deliveryAddress?.address || localStorage.getItem("cateringDeliveryAddress")}</span></div>
                                <div className="invoice-row"><span>Delivery Date:</span><span>{cateringDate} at {cateringTime}</span></div>
                                <div className="invoice-note thank-you">Thank you for ordering with Maamaas Foods! 🍽️</div>
                            </div>
                        )}
                        <button className="cart-continue-btn" onClick={() => {
                            setShowPaymentData(false);
                            setPaymentBreakdown(null);
                            setShowPaymentOptions(false);
                            setSelectedPaymentMethod(null);
                            setIsWalletChecked(false);
                            setIsOnlineChecked(false);
                            fetchCartDetails();
                            if (onClose) onClose();
                        }}>Continue Shopping</button>
                    </div>
                ) : cartItems.length === 0 ? (
                    <div className="cart-empty">
                        <div className="cart-empty-icon"><ShoppingCartIcon /></div>
                        <p>Your cart is empty</p>
                        <span>Add delicious catering packages from the menu</span>
                    </div>
                ) : (
                    <>
                        <div className="cart-items-list">
                            {cartItems.map(item => {
                                const qty = item.quantity || 1;
                                let price = item.price || item.totalPrice || item.packagePrice || 0;
                                price = parseFloat(price);
                                return (
                                    <div key={item.packageId} className="cart-item">
                                        <div className="cart-item-top">
                                            <div className="cart-item-info">
                                                <div className="cart-item-name">{item.packageName}</div>
                                                <div className="cart-item-price">₹{price.toFixed(2)}</div>
                                                <div className="cart-item-type">
                                                    <span className={`package-type-badge ${item.packageType === 'Veg' ? 'veg' : 'nonveg'}`}>
                                                        {item.packageType === 'Veg' ? ' Veg' : ' Non-Veg'}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="cart-qty-controls">
                                                <button className="cart-qty-btn" onClick={() => decrementQuantity(item)}>
                                                    {qty === 1 ? '🗑' : '−'}
                                                </button>
                                                <span className="cart-qty-num">{qty}</span>
                                                <button className="cart-qty-btn" onClick={() => incrementQuantity(item)}>+</button>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        <div className="cart-summary">
                            <div className="cart-summary-row"><span>Sub Total</span><span>₹{subTotal.toFixed(2)}</span></div>
                            <div className="cart-summary-row">
                                <span>GST <BsInfoCircleFill onClick={handleShowGST} style={{ fontSize: '11px', cursor: 'pointer', color: '#ee6521' }} /></span>
                                <span>₹{gstTotal.toFixed(2)}</span>
                            </div>
                            <div className="cart-summary-row">
                                <span>Service Charges <button className="cart-toggle-service" onClick={toggleServiceCharges}>{serviceApplied ? 'Remove' : 'Apply'}</button></span>
                                <span>₹{serviceCharges.toFixed(2)}</span>
                            </div>
                            <div className="cart-summary-total"><span>Grand Total</span><span>₹{grandTotal.toFixed(2)}</span></div>
                        </div>
                        {!showPaymentOptions ? (
                            <button onClick={() => setShowPaymentOptions(true)} className={`cart-bill-btn ${cartItems.length > 0 ? 'cart-bill-btn--active' : 'cart-bill-btn--disabled'}`}>
                                {cartItems.length > 0 ? '🧾 Proceed to Payment' : 'Add items to continue'}
                            </button>
                        ) : (
                            <div className="cart-payment-section">
                                <div className="cart-payment-title">Select Payment Method</div>
                                <div className="cart-payment-options">
                                    <div className={`cart-payment-option ${selectedPaymentMethod === 'Maamaas_Wallet' ? 'selected' : ''}`} onClick={() => handleCheckboxChange('wallet', !isWalletChecked)}>
                                        <input type="checkbox" checked={isWalletChecked} onChange={e => handleCheckboxChange('wallet', e.target.checked)} />
                                        <span>👛 Wallet (₹{availableBalance.toFixed(2)})</span>
                                    </div>
                                    {showWalletOptions && (
                                        <div className="cart-wallet-options">
                                            <label><input type="radio" name="walletType" value="SELF_LOADED" checked={selectedWalletType === "SELF_LOADED"} onChange={e => setSelectedWalletType(e.target.value)} /> Self (₹{availableSelf.toFixed(2)})</label>
                                            <label><input type="radio" name="walletType" value="COMPANY_LOADED" checked={selectedWalletType === "COMPANY_LOADED"} onChange={e => setSelectedWalletType(e.target.value)} /> Company (₹{availableCompany.toFixed(2)})</label>
                                            <label><input type="radio" name="walletType" value="CASHBACK" checked={selectedWalletType === "CASHBACK"} onChange={e => setSelectedWalletType(e.target.value)} /> Cashback (₹{availableCashback.toFixed(2)})</label>
                                        </div>
                                    )}
                                    <div className={`cart-payment-option ${selectedPaymentMethod === 'Online_Payment' ? 'selected' : ''}`} onClick={() => handleCheckboxChange('online', !isOnlineChecked)}>
                                        <input type="checkbox" checked={isOnlineChecked} onChange={e => handleCheckboxChange('online', e.target.checked)} />
                                        <span>💳 Online Payment (Razorpay)</span>
                                    </div>
                                </div>
                                <button
                                    onClick={async () => {
                                        if (!selectedPaymentMethod) {
                                            toast.error("Please select payment method");
                                            return;
                                        }

                                        if (selectedPaymentMethod === "Maamaas_Wallet") {
                                            await processWalletPayment();
                                        } else {
                                            await handleCheckoutClick();
                                        }
                                    }}
                                    disabled={orderPlacing}
                                    className="cart-pay-btn"
                                >
                                    {orderPlacing ? "Processing..." : `Pay ₹${grandTotal.toFixed(2)}`}
                                </button>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );

    return (
        <div>
            {/* <Vendorbanner /> */}
        
        <div className="menu-page-wrapper">
           
             
            <div className="menu-content">
                <div className="menu-table-banner">
                    <div><span className="menu-table-name">🍽️ Catering Menu</span></div>
                    <button className="menu-view-bookings-btn" onClick={() => navigate('/Myordermain')}>View Orders →</button>
                </div>
                <div className="menu-filter-bar">
                    <div className="menu-filter-left">
                        <span className="menu-filter-label">Filters</span>
                        {(searchTerm || isVegSelected || isNonVegSelected) && (
                            <button className="menu-clear-filters" onClick={() => { setSearchTerm(""); setIsVegSelected(false); setIsNonVegSelected(false); }}>✕ Clear</button>
                        )}
                    </div>
                    <div className="menu-filter-right">
                        <input type="text" placeholder="Search packages..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="menu-search-input" />
                        <button className={`menu-chip menu-chip--veg ${isVegSelected ? 'active' : ''}`} onClick={() => { setIsVegSelected(!isVegSelected); setIsNonVegSelected(false); }}>🌱 Veg</button>
                        <button className={`menu-chip menu-chip--nonveg ${isNonVegSelected ? 'active' : ''}`} onClick={() => { setIsNonVegSelected(!isNonVegSelected); setIsVegSelected(false); }}>🍗 Non-Veg</button>
                    </div>
                </div>
                <div className="menu-dishes-grid">
                    {filteredPackages.map(pkg => {
                        const packageTotal = pkg.calculatedTotal || getPackageTotal(pkg);
                        return (
                            <div key={pkg.id} className="menu-dish-card">
                                <div className="dish-body">
                                    <div className="dish-name-row">
                                        <h5 className="dish-name">{pkg.packageName}</h5>
                                        <span className={`dish-tag-dot ${pkg.packageType === 'Veg' ? 'veg' : 'nonveg'}`} />
                                    </div>
                                    {pkg.items?.length > 0 && (
                                        <div className="package-items-list">
                                            {pkg.items.slice(0, 3).map(item => <span key={item.id} className="package-item-tag">{item.itemName} (₹{parseFloat(item.price).toFixed(2)})</span>)}
                                            {pkg.items.length > 3 && <span className="package-item-more">+{pkg.items.length - 3} more</span>}
                                        </div>
                                    )}
                                    <div className="dish-price-row"><span className="dish-price-effective">₹{packageTotal.toFixed(2)}</span></div>
                                    <button onClick={() => addToCart(pkg)} className="dish-add-btn"><ShoppingCartIcon />Add to Cart</button>
                                </div>
                            </div>
                        );
                    })}
                </div>
                {filteredPackages.length === 0 && <div className="no-results"><p>No packages found matching your criteria</p></div>}
            </div>

            {!isMobile && <div className="cart-desktop-wrapper"><CartSidebar isMobileView={false} /></div>}

            {isMobile && !showPaymentData && (
                <button className="cart-fab" onClick={() => setIsCartPanelOpen(true)}>
                    <ShoppingCartIcon />
                    {cartItemsCount > 0 && <span className="cart-fab-badge">{cartItemsCount}</span>}
                </button>
            )}

            {isMobile && isCartPanelOpen && (
                <>
                    <div className="cart-overlay" onClick={() => setIsCartPanelOpen(false)} />
                    <CartSidebar isMobileView={true} onClose={() => setIsCartPanelOpen(false)} />
                </>
            )}

            {/* GST Popup */}
            {showGstPopup && gstBreakdownData && (
                <div className="popup-overlay" onClick={() => setShowGstPopup(false)}>
                    <div className="popup-box" onClick={e => e.stopPropagation()}>
                        <h3 className="popup-title">GST Breakdown</h3>
                        <div className="popup-row"><span>CGST (2.5%)</span><span>₹{gstBreakdownData.cgst.toFixed(2)}</span></div>
                        <div className="popup-row"><span>SGST (2.5%)</span><span>₹{gstBreakdownData.sgst.toFixed(2)}</span></div>
                        <div className="popup-total"><span>Total GST</span><span>₹{(gstBreakdownData.cgst + gstBreakdownData.sgst).toFixed(2)}</span></div>
                        <button className="popup-close-btn" onClick={() => setShowGstPopup(false)}>Close</button>
                    </div>
                </div>
            )}

            {/* Address Modal */}
            {showAddressModal && (
                <div className="popup-overlay">
                    <div className="popup-box address-modal">
                        <h3 className="popup-title">📍 Select Delivery Address</h3>
                        <div className="address-form">
                            <div className="location-search-container">
                                <div className="search-wrapper">
                                    <input ref={searchInputRef} type="text" placeholder="Search for your address..." className="address-search-input" value={searchInput} onChange={(e) => setSearchInput(e.target.value)} />
                                    <button className="current-location-btn" onClick={getCurrentLocation} disabled={loadingLocation}>
                                        <LocationIcon /> {loadingLocation ? "Getting..." : "Current Location"}
                                    </button>

                                </div>
                                <div
                                    id="address-map"
                                    style={{
                                        width: "100%",
                                        height: "300px",
                                        marginTop: "10px",
                                        borderRadius: "10px"
                                    }}
                                />
                                {selectedPlace?.geometry && (
                                    <div className="selected-location-info"><div className="location-confirm"><span className="confirm-icon">✓</span><span>Address selected</span></div></div>
                                )}
                            </div>
                            <div className="schedule-actions">
                                <button className="schedule-cancel-btn" onClick={() => { setShowAddressModal(false); setSearchInput(""); setSelectedPlace(null); }}>Cancel</button>
                                <button className="schedule-confirm-btn" onClick={async () => {
                                    const addressToSave = searchInput || deliveryAddress?.address;
                                    if (addressToSave) {
                                        const success = await saveDeliveryAddress(addressToSave);
                                        if (success) { setShowAddressModal(false); setSearchInput(""); setSelectedPlace(null); }
                                    } else toast.error("Please select or enter an address");
                                }}>Save Address</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Date & Time Modal */}
            {showDateTimeModal && (
                <div className="popup-overlay">
                    <div className="popup-box">
                        <h3 className="popup-title">📅 Select Delivery Date & Time</h3>
                        <div className="schedule-form">
                            <input type="date" value={cateringDate} onChange={e => setCateringDate(e.target.value)} min={new Date().toISOString().split("T")[0]} className="schedule-input" />
                            <input type="time" value={cateringTime} onChange={e => setCateringTime(e.target.value)} className="schedule-input" />
                            <div className="schedule-actions">
                                <button className="schedule-cancel-btn" onClick={() => setShowDateTimeModal(false)}>Cancel</button>
                                <button className="schedule-confirm-btn" onClick={async () => { const success = await updateDateTime(); if (success) { setShowDateTimeModal(false); await fetchCartDetails(); } }}>Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
        </div>
    );
};

export default CateringMenu;